export const Permissions = {
    NONE: 0,      // ❌ No Access
    READ: 1,      // 👁️ Read only
    WRITE: 2,     // ✏️ Write access
};

export const PermissionIcons = {
    0: "❌",  // No Access
    1: "👁️",  // Read
    2: "✏️",  // Write

};

export const PermissionSections = [
    "settlements",
    "crew",
    "tickets",
    "venues",
    "itinerary",
    "setlists",
    "guestlists",
    "merchandise"
];

export const PermissionSectionNames = {
    itinerary: "Itinerary",
    tickets: "Ticketing",
    venues: "Venue Management",
    crew: "User Management",
    setlists: "Setlists",
    settlements: "Settlements",
    guestlists: "Guest Lists",
    merchandise: "Merchandise"
};

export const PermissionsMap = [
    { "id": Permissions.NONE, "name": "No Access", "icon": "❌" },
    { "id": Permissions.READ, "name": "Read", "icon": "👁️" },
    { "id": Permissions.WRITE, "name": "Write", "icon": "✏️" }
];

// Permission Groups for better organization
export const PermissionGroups = {
    ADMINISTRATIVE: {
        name: "Administrative",
        icon: "⚙️",
        description: "Core administrative functions",
        sections: ["settlements", "crew"]
    },
    CONTENT: {
        name: "Content Management",
        icon: "📝",
        description: "Content creation and management",
        sections: ["setlists", "guestlists"]
    },
    OPERATIONS: {
        name: "Operations",
        icon: "🎭",
        description: "Day-to-day operations",
        sections: ["tickets", "venues", "itinerary", "merchandise"]
    }
};

// Role-based permission templates
export const RoleTemplates = {
    ADMIN: {
        name: "Admin",
        description: "Full access to all areas",
        icon: "👑",
        color: "#d32f2f",
        permissions: {
            "settlements": 2,
            "crew": 2,
            "tickets": 2,
            "venues": 2,
            "itinerary": 2,
            "setlists": 2,
            "guestlists": 2,
            "merchandise": 2
        }
    },
    MANAGER: {
        name: "Manager",
        description: "Management access with some restrictions",
        icon: "👨‍💼",
        color: "#1976d2",
        permissions: {
            "settlements": 1,
            "crew": 2,
            "tickets": 2,
            "venues": 2,
            "itinerary": 2,
            "setlists": 2,
            "guestlists": 2,
            "merchandise": 2
        }
    },
    TOUR_MANAGEMENT: {
        name: "Tour Management",
        description: "Full operational management access",
        icon: "📋",
        color: "#fb8c00",
        permissions: {
            "settlements": 0,
            "crew": 2,
            "tickets": 2,
            "venues": 2,
            "itinerary": 2,
            "setlists": 2,
            "guestlists": 2,
            "merchandise": 2
        }
    },
    CREW_MEMBER: {
        name: "Crew Member",
        description: "Operational access for crew",
        icon: "👷",
        color: "#388e3c",
        permissions: {
            "settlements": 0,
            "crew": 0,
            "tickets": 0,
            "venues": 0,
            "itinerary": 0,
            "setlists": 1,
            "guestlists": 1,
            "merchandise": 0
        }
    },
    GUEST: {
        name: "Guest",
        description: "No module access — only sees assigned activities",
        icon: "👥",
        color: "#757575",
        permissions: {
            "settlements": 0,
            "crew": 0,
            "tickets": 0,
            "venues": 0,
            "itinerary": 0,
            "setlists": 0,
            "guestlists": 0,
            "merchandise": 0
        }
    },
    CUSTOM: {
        name: "Custom",
        description: "Custom permission configuration",
        icon: "🔧",
        color: "#f57c00",
        permissions: {} // Empty - to be filled by user
    }
};

// Enhanced permission icons with better visibility
export const ModernPermissionIcons = {
    0: { icon: "🚫", color: "#f44336", label: "No Access" },      // Red
    1: { icon: "👁️", color: "#2196f3", label: "Read Only" },      // Blue
    2: { icon: "✏️", color: "#4caf50", label: "Read & Write" }    // Green
};

// Legacy matrix for backward compatibility
const PermissionsMatrix = {
    "admin": RoleTemplates.ADMIN.permissions,
    "manager": RoleTemplates.MANAGER.permissions,
    "user": RoleTemplates.CREW_MEMBER.permissions
};